document.addEventListener('DOMContentLoaded', function() {
  var calendarEl = document.getElementById('calendar');

  var calendar = new FullCalendar.Calendar(calendarEl, {

    googleCalendarApiKey: 'AIzaSyBh4BOFF-krIwEH-1sanPpSxf5SbIqfIkM',
    eventSources: [
      {
        googleCalendarId: 'esqd4n30kd75t6hqabbmrd6334@group.calendar.google.com',//自分で作成したカレンダー
        display: 'gcal-event',
        className: 'gcal-event'
      },
      {
        googleCalendarId: '03f1c942e22b7c18be9bff24ff39b2918e6822d494f346a151b14a0b2ce4e51e@group.calendar.google.com',//自分で作成したカレンダー
        display: 'background',
        className: 'gcal-holiday'
      }
    ],
    initialView: 'dayGridMonth',//デフォルトを月表示にする
    headerToolbar: {
      left: '',
      center: 'title',
      right: 'prev,today,next'//ボタンの並び順
    },
    buttonText: {
      today: '今月',
      month: '月'
    },
    eventDidMount: (e) => {
      let message = e.event.title;

      if (e.event.allDay === false) {
        const start = formatTime(e.event.start);
        const end = formatTime(e.event.end);
        message = start + "-" + end + " " + message;
      }

      if (e.event.extendedProps.description !== undefined) {
        let detail = e.event.extendedProps.description;

        // Googleカレンダーのリンクを削除（詳細欄にある場合）
        detail = detail.replace(/<a [^>]*href=["']https:\/\/www\.google\.com\/calendar[^>]*>.*?<\/a>/gi, '');

        // 他のリンクは新しいタブで開く
        detail = detail.replace(/<a /g, '<a target="_blank" ');

        message = message + '<div class="description">' + detail + '</div>';
      }

      // FullCalendar が生成した <a> タグの href を削除
      setTimeout(() => {
        e.el.removeAttribute("href"); // <a> の href を削除（無効化）
      }, 0);
      tippy(e.el, {
        content: message,
        interactive: true,
        allowHTML: true,
        placement: 'top',
      });
    },
    locale: 'ja',//日本語表示設定
    dayCellContent: function (e) {
      e.dayNumberText = e.dayNumberText.replace('日', '');//日付のセルから日を削除
    },
    fixedWeekCount: false,//6週間表示をやめる
  });
  if( $("#calendar").length ){
    calendar.render();
  }
});